<template>
    <div>
        <div class="mask" v-if="showMask"></div>
        <div class="main">
            <div class="dialog-view" v-loading="loading">
                <div class="view-top">
                    <div class="left">
                        历史变更记录
                    </div>
                    <div class="right">
                        <i @click="closeDetail" class="el-icon-close" style="color:#000;cursor: pointer;"></i>
                    </div>
                </div>
                <div class="view-search">
                    <el-form :inline="true" :model="searchForm" ref="searchForm">
                        <el-form-item class="search-item" prop="searchType">
                            <el-select v-model="searchForm.searchType" placeholder="选择变更类型" size="small" clearable>
                                <el-option v-for="(item)  in searchTypearr"  :key="item.key" :label="item.value" :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="search-item" prop="searchPerson">
                            <el-select v-model="searchForm.searchPerson" placeholder="选择变更人" size="small" clearable>
                                <el-option v-for="(item)  in searchPersonarr"  :key="item.key" :label="item.value" :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="search-item" style="width:60px;">
                            <el-button type="danger" size="small" @click="queryForm()">搜索</el-button>
                        </el-form-item>
                        <el-form-item class="search-item" style="width:60px;">
                            <el-button type="info" size="small" @click="resetForm()">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="search-table">
                    <el-table
                    :data="tableData"
                    style="width: 100%"
                    tooltip-effect="dark"
                    border
                    show-header
                    :default-sort = "{prop: 'date', order: 'descending'}"
                    >
                    <!-- @sort-change="changeTableSort" -->
                    <el-table-column
                    prop="date"
                    label="变更时间"
                    align="center"
                    sortable
                    show-overflow-tooltip
                    width="180">
                    <!--:sortable="'custom'" -->
                    </el-table-column>
                    <el-table-column
                    prop="name"
                    label="变更类型"
                    align="center"
                    width="100">
                    </el-table-column>
                    <el-table-column
                    prop="name"
                    label="变更人"
                    align="center"
                    width="80">
                    </el-table-column>
                    <el-table-column
                    prop="name"
                    label="原售点信息"
                    align="center"
                    show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                    prop="name"
                    label="变更后售点信息"
                    align="center"
                    show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                    prop="name"
                    label="原活动执行日期"
                    align="center"
                    show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                    prop="name"
                    label="变更后活动执行日期"
                    align="center"
                    show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                    prop="address"
                    align="center"
                    show-overflow-tooltip
                    label="替换理由"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="address"
                    align="center"
                    show-overflow-tooltip
                    label="替换凭证"
                    >
                    <template slot-scope="scope">
                        <div style="color:#4E73F9;cursor: pointer;" @click="viewImage(scope.row)">查看详情</div>
                    </template>
                    </el-table-column>
                </el-table>
                </div>
                <div class="search-bottom" v-if="tableData.length > 0">
                    <el-pagination
                        background
                        :total="searchForm.total"
                        layout="total, prev, pager, next"
                        :current-page="searchForm.page"
                        :page-size="searchForm.pageSize"
                        @current-change="handleCurrentChange">
                        <span style="text-align: center">{{searchForm.page}}/{{searchForm.allPage}}</span>
                    </el-pagination>
                </div>
                <el-empty description="暂无提报数据" v-if="tableData.length == 0"></el-empty>
                <div class="view-btn">
                    <div class="btn" @click="closeDetail">返回</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import gameplanApi from '../../../api/gameplan';
    export default {
      name: 'report-update-pop',
      props: {
        params:{type:Object, default:{} },
      },
      components: {
      },
      data () {
        return { 
            reportDetail:{},//提报数据详情
            execDataConfigList:[],
            storeslist:[], // 门店情况统计
            singleStorelist:[], //单店执行情况
            singleStoresplicelist:[], //单店执行情况 删除表格相关信息
            loading:false,
            dialogImage:false,
            showMask:false,
            imageList:[],
            tableData: [{
                date: '2016-05-02',
                name: '王小虎2',
                address: '上海市普陀区金沙江路 1518 弄'
                }, {
                date: '2016-05-04',
                name: '王小虎4',
                address: '上海市普陀区金沙江路 1517 弄'
                }, {
                date: '2016-05-01',
                name: '王小虎1',
                address: '上海市普陀区金沙江路 1519 弄'
                }, {
                date: '2016-05-03',
                name: '王小虎3',
                address: '上海市普陀区金沙江路 1516 弄'
                }],
            searchForm: {
                searchType: null,
                searchPerson: null,
                page:1,
                pageSize: 5,
                total: 20,
                allPage: 4,
            },
            searchTypearr: [
                {'key':1,'value':"111"},
                {'key':2,'value':"222"},
                {'key':3,'value':"333"},
            ],
            searchPersonarr: [
                {'key':4,'value':"444"},
                {'key':5,'value':"555"},
                {'key':6,'value':"666"},
            ]
        }
      },
      computed: {
      },
      watch: {},
      created () {
        this.init()
      },
      mounted () {},
      updated () {
      },
      methods: {
        init () {
            // this.getExecDataConfig()
        },
        changeTableSort (column) {
            console.log(column,'column');

        },
        viewImage (row) {
            console.log(row,'999');
            this.imageList = []
            this.showMask = true
            this.dialogImage = true
        },
        queryForm () {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    this.searchForm.page = 1
                } else {
                    return false;
                }
            });
        },
        resetForm () {
            this.$refs.searchForm.resetFields();
            this.searchForm.page = 1
        },
        handleCurrentChange (val) {
            this.searchForm.page = val
        },

        closeDetail () {
            this.$emit('closeChangepop')
        },
        closeImage () {
            this.showMask = false
            this.dialogImage = false
        }
    }
}
</script>
<style lang="scss" scoped>
.mask{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0,0,0,.7) ;
    z-index: 4;
}
.main {
    .dialog-view {
        position: fixed;
        border-radius: 8px;
        width: 80%;
        top: 5%;
        left: 10%;
        min-height: 300px;
        max-height: 80vh;
        padding: 20px 27px 20px 27px;
        background-color: #FFFFFF;
        color: #101010;
        z-index: 3;
        overflow: hidden;
        overflow-y: scroll;
        .view-top {
            height: 32px;
            line-height: 32px;
            display: flex;
            margin-bottom: 15px;
            .left {
                font-size: 16px;
                font-weight: 600;
                flex: 1;
            }
            .right {
                width: 32px;
                height: 32px;
                font-size: 32px;
                color: #999191;
            }
        }
        .view-search {
            display: flex;
            margin-bottom: 10px;
            .search-item {
                width: 190px;
                line-height: 40px;
                margin: 0px 10px 0px 0px;
            }
        }
        .search-table {
            ::v-deep .el-table th.el-table__cell {
                color: #101010;
                background-color: rgba(232, 232, 232);
            }
            ::v-deep .el-table__body tr.current-row>td.el-table__cell {
                background-color: #FFFFFF !important;
            }
            ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
                background-color: #FFFFFF !important;
            }

        }
        .search-bottom {
            // position: relative;
            // top: 20px;
            margin: 20px 0px 0px 0px;
            text-align: center;
            ::v-deep .el-pagination.is-background .btn-next,
            ::v-deep .el-pagination.is-background .btn-prev{
                background-color: #FFFFFF;
                color: #000;
                border: 1px solid #C0C4CC;
                border-radius: 3px;
            }
            ::v-deep .el-pagination.is-background .btn-next:disabled,
            ::v-deep .el-pagination.is-background .btn-prev:disabled,
            ::v-deep .el-pagination.is-background .el-pager li.disabled {
                color: #C0C4CC;
            }
        }
        .view-btn {
            margin: 30px 0px 0px 0px;
            height: 30px;
            line-height: 30px;
            .btn {
                margin: auto;
                width: 80px;
                text-align: center;
                background-color: #FFFFFF;
                color: #cd1231;
                border-radius: 5px;
                border: 1px solid #cd1231;
                cursor: pointer;
            }
        }
    }
}
</style>
